import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useForm } from "../../hooks/useForm";
import { Alert } from "@mui/material";

export default function Navbar({ QuoteService }) {
  const [showModal, setShowModal] = useState(false); //!
  const location = useLocation();

  const [menuOpen, setMenuOpen] = useState(false);
  const menuButtonRef = useRef(null);

  const { formValues, handleChange, handleSubmit, isLoading, alertMessage } =
    useForm("/contact", "POST", true);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = (event) => {
    if (
      menuButtonRef.current &&
      !menuButtonRef.current.contains(event.target)
    ) {
      setMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", closeMenu);
    return () => {
      document.removeEventListener("click", closeMenu);
    };
  }, []);
  const handleOpenModal = () => {
    setShowModal(true);
  }; //!

  const handleCloseModal = () => {
    setShowModal(false);
  }; //!

  const handleContactUsClick = () => {
    // Define the logic for handling contact us click
    console.log("Contact Us clicked");
    // Example: Triggering modal open
    handleOpenModal();
  }; //!

  const handleHomeClick = (event) => {
    if (location.pathname === "/") {
      event.preventDefault();
      window.location.reload();
    }
  };

  return (
    <>
      <nav
        className="navbar navbar-expand-lg"
        style={{
          position: "sticky",
          top: 0,
          zIndex: 1000,
          backgroundColor: "rgb(243, 243, 243)",
        }}
      >
        <div className="container">
          <Link
            to="/"
            className="navbar-brand"
            aria-current="page"
            style={{ textAlign: "center" }}
            onClick={handleHomeClick}
          >
            <img
              src="/assets/images/falconLogo.png"
              alt="logo"
              width="90"
              height="80"
              className="d-inline-block align-text-top"
            />
          </Link>
          <button
            className="navbar-toggler"
            ref={menuButtonRef}
            onClick={toggleMenu}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className={`collapse navbar-collapse ${menuOpen ? "show" : ""}`}
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link
                  to="/"
                  className={`nav-link font-good ${
                    location.pathname === "/" ? "active" : ""
                  }`}
                  aria-current="page"
                  onClick={handleHomeClick}
                >
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/ourStory"
                  className={`nav-link font-good ${
                    location.pathname === "/ourStory" ? "active" : ""
                  }`}
                  aria-current="page"
                >
                  Our Story
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/service"
                  className={`nav-link font-good ${
                    location.pathname === "/service" ? "active" : ""
                  }`}
                  aria-current="page"
                >
                  Our Services
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="#"
                  className="nav-link font-good"
                  onClick={handleContactUsClick}
                  aria-current="page"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      {showModal && (
        <div className="modal modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header" style={{ backgroundColor: "white" }}>
                <div
                  className="container services-card py-5 pt-1 mt-4 pb-3 align-items-center justify-content-center text-center"
                  style={{ width: "280px" }}
                >
                  {/* <h4 style={{color:'#4a259b', fontSize:'16px',textAlign:'center',paddingTop:'8px'}}>Contact Us</h4> */}
                  <i
                    class="fa-solid fa-comments icon"
                    style={{ fontSize: "3rem" }}
                  ></i>
                  <h4
                    style={{
                      color: "#4a259b",
                      fontSize: "17px",
                      textAlign: "center",
                      paddingTop: "5px",
                    }}
                  >
                    How can we help?
                  </h4>
                  <p
                    style={{
                      fontSize: "0.8rem",
                      textAlign: "center",
                      fontFamily: "gothic",
                    }}
                  >
                    Contact us and we will respond to you at the
                    earliest convenience.{" "}
                  </p>
                </div>
              </div>
              {alertMessage && (
                <Alert
                  severity={
                    alertMessage.type === "success" ? "success" : "error"
                  }
                >
                  {alertMessage.message}
                </Alert>
              )}
              <div class="modal-body">
                <form
                  onSubmit={handleSubmit}
                  style={{
                    fontFamily: "gothic",
                  }}
                >
                  <div class="form-group">
                    <label>Name:</label>
                    <input
                      type="text"
                      class="form-control"
                      name="client_name"
                      value={formValues.client_name || ""}
                      onChange={handleChange}
                      required
                    ></input>
                  </div>
                  <div class="form-group">
                    <label>Phone number:</label>
                    <input
                      type="text"
                      class="form-control"
                      name="client_phone"
                      value={formValues.client_phone || ""}
                      onChange={handleChange}
                      required
                    ></input>
                  </div>
                  <div class="form-group">
                    <label>Email address:</label>
                    <input
                      type="email"
                      class="form-control"
                      name="client_email"
                      value={formValues.client_email || ""}
                      onChange={handleChange}
                      required
                    ></input>
                  </div>
                  <div class="form-group">
                    <label>Write your message here:</label>
                    <input
                      type="text"
                      class="form-control"
                      style={{ height: "100px" }}
                      name="notes"
                      value={formValues.notes || ""}
                      onChange={handleChange}
                      required
                    ></input>
                  </div>
                  <div
                    class="modal-footer"
                    style={{ display: "flex", justifyContent: "start" }}
                  >
                    <button
                      type="button"
                      class="btn"
                      data-bs-dismiss="modal"
                      onClick={handleCloseModal}
                      style={{ backgroundColor: "#4a259b", color: "white" }}
                    >
                      Close
                    </button>
                    <button
                      type="submit"
                      class="btn"
                      data-bs-dismiss="modal"
                      style={{ backgroundColor: "#4a259b", color: "white" }}
                      disabled={isLoading}
                    >
                      {isLoading ? "Sending..." : "Send"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
